var exports = {
  "container": "x9bf38834--71f819--container",
  "title": "x9bf38834--71f819--title",
  "cta-wrap": "x9bf38834--71f819--cta-wrap",
  "blocks": "x9bf38834--71f819--blocks",
  "block": "x9bf38834--71f819--block",
  "block-step": "x9bf38834--71f819--block-step",
  "block-title": "x9bf38834--71f819--block-title",
  "block-image": "x9bf38834--71f819--block-image",
  "phone": "x9bf38834--71f819--phone",
};

module.exports = exports;
